import { render, staticRenderFns } from "./CreateColorSwatchModal.vue?vue&type=template&id=4a2f5d58"
import script from "./CreateColorSwatchModal.vue?vue&type=script&lang=js"
export * from "./CreateColorSwatchModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports